import React from "react";
import styles from "./FlickerText.module.scss";

const FlickerText = ({ text }) => (
  <span className={styles.animateFlicker}>{text}</span>
);

export default FlickerText;
